angular.module 'zc.commonApi'

.factory "ReportCampaignStats", ($q, FacadeV2) ->

  class ReportCampaignStats

    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/report_campaign_stats/#{paths.dimension}/find",
        params: params
      .then (res) ->
        ReportCampaignStats.transformReport(res.data)

    @transformReport: (data) ->
      try
        for stats in data
          cumulatives =
            experimental:
              conversion_count: stats.experimental.conversion_count
              conversion_price: stats.experimental.conversion_price
              delivery_count: stats.experimental.delivery_count
            control:
              conversion_count: stats.control.conversion_count
              conversion_price: stats.control.conversion_price
              delivery_count: stats.control.delivery_count
            contribution_count: stats.contribution_count
            contribution_price: stats.contribution_price

          cumulatives.experimental.average_conversion_price =
            cumulatives.experimental.conversion_price /
            cumulatives.experimental.conversion_count || 0
          cumulatives.control.average_conversion_price =
            cumulatives.control.conversion_price /
            cumulatives.control.conversion_count || 0

          cumulatives.experimental.conversion_rate =
            cumulatives.experimental.conversion_count /
            cumulatives.experimental.delivery_count || 0
          cumulatives.control.conversion_rate =
            cumulatives.control.conversion_count /
            cumulatives.control.delivery_count || 0

          # up rate
          if cumulatives.control.conversion_rate == 0
            cumulatives.conversion_up_rate = 0
          else
            cumulatives.conversion_up_rate =
              (cumulatives.experimental.conversion_rate /
               cumulatives.control.conversion_rate) || 0
          angular.extend(stats, cumulatives)
        data
      catch
        {}

  ReportCampaignStats



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/report_campaign_stats.service.coffee